module.exports = __webpack_public_path__ + "img/PersonalTecnico.88c0a4de.svg";